import { createUseProvidedContext } from '@stenngroup/utilities';

import { LangContext } from '../context';
import { ILangContext } from '../types';

export const useLangContext = createUseProvidedContext<ILangContext>(LangContext, 'LangContext');
